export default {
  expenses: [],
};
